import React from 'react';
import { Link } from 'react-router-dom';
import Authorization from '../Auth/Authorization/Authorization';
import img from './../../assets/img/logo.svg';
import TemporalyDrawer from './drawer';
import './navigation.css';
var Navigation = function () {
    return (React.createElement("div", { className: "navbar" },
        React.createElement(TemporalyDrawer, null),
        React.createElement(Link, { to: '/' },
            React.createElement("img", { src: img, alt: "rs-logo", className: "rs-logo" })),
        React.createElement("div", { className: "button-group-user" },
            React.createElement(Authorization, null))));
};
export default Navigation;
